import type { ScreenShareCaptureOptions, TrackPublishOptions } from 'livekit-client';

/**
 * Options de publication du partage d'écran, optimisées pour des slides/PDF pleins de texte.
 * Sans ces réglages, LiveKit sacrifie la résolution pour garder le framerate dès que le débit
 * baisse → texte flou à la source. On privilégie la netteté à la fluidité (le contenu est quasi
 * statique) et on remonte un peu le plancher de bitrate.
 */
export function buildScreenShareOptions(): {
  capture: ScreenShareCaptureOptions;
  publish: TrackPublishOptions;
} {
  return {
    capture: {
      audio: true,
      // Indique à l'encodeur de préserver les détails (contours des lettres) plutôt que le mouvement.
      contentHint: 'detail',
    },
    publish: {
      // Sous congestion : on baisse les fps, jamais la résolution.
      degradationPreference: 'maintain-resolution',
      // En simulcast, LiveKit recalcule les encodages depuis ses presets (~1,5 Mbps) et ignore
      // screenShareEncoding : couche unique pour que nos 4 Mbps s'appliquent vraiment.
      simulcast: false,
      // Plancher relevé (défaut LiveKit : 2,5 Mbps) pour laisser au texte de quoi rester net.
      screenShareEncoding: { maxBitrate: 4_000_000, maxFramerate: 15 },
    },
  };
}
